import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { themeSpace } from 'styles/themeUtils';

const HeadingTypography = styled(Typography)`
  margin-bottom: ${themeSpace(1)};
  &:last-child {
    margin-bottom: 0px;
  }

  text-align: center;
`;

HeadingTypography.displayName = 'HeadingTypography';

export default HeadingTypography;
